import { settings } from '../config';
import { setItemToStore } from '../helpers/utils';

/**
 * Reducer para manejar la configuración global de la aplicación.
 * Permite establecer nuevas configuraciones, refrescar el estado y reiniciar los valores por defecto.
 *
 * @param {Object} state - Estado actual de la configuración.
 * @param {Object} action - Acción que contiene el tipo y el payload.
 * @param {string} action.type - Tipo de acción ('SET_CONFIG', 'REFRESH', 'RESET').
 * @param {Object} action.payload - Datos asociados a la acción.
 * @returns {Object} Nuevo estado actualizado.
 */
export const configReducer = (state, action) => {
	const { type, payload } = action;

	switch (type) {
		/**
		 * Establece un valor de configuración.
		 * Si `setInStore` es `true`, también lo guarda en localStorage.
		 */
		case 'SET_CONFIG':
			if (payload.setInStore) {
				setItemToStore(payload.key, payload.value);
			}
			return {
				...state,
				[payload.key]: payload.value
			};

		/**
		 * Refresca el estado sin modificarlo.
		 */
		case 'REFRESH':
			return {
				...state
			};

		/**
		 * Reinicia el estado de configuración a los valores por defecto.
		 * También limpia todo el localStorage.
		 */
		case 'RESET':
			localStorage.clear();
			return {
				...state,
				...settings
			};

		/**
		 * Acción por defecto si el tipo no coincide.
		 */
		default:
			return state;
	}
};